import {management} from '../../../../index'

import {SectorHasFarmRepository} from '../../../infra/knex/repositories/sector_has_farm'
import {CheckIfExistsSectorUseCase} from './checkIfHasSector'


export const checkIfFarmHasSector=new CheckIfExistsSectorUseCase(new SectorHasFarmRepository(management))
